
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { GroupUserItemProps } from ".";
import { loading, find, findUser } from "store/group-user";
import { UserItemProps } from "apis/user";

interface ApiGroupUserFindByIdInputProps {
    id: number;
}

type ApiGroupUserFindOutputProps = OutputBaseProps<{ item: GroupUserItemProps; }, ApiGroupUserFindByIdInputProps>

export const apiGroupUserFindById = async (data: ApiGroupUserFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiGroupUserFindOutputProps>(`/api/group/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiGroupUserFindByCodeInputProps {
    code: string;
}

export const apiGroupUserFindByCode = async (data: ApiGroupUserFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiGroupUserFindOutputProps>(`/api/group/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};



type ApiGroupUserFindUsersOutputProps = OutputBaseProps<{ list: UserItemProps[]; }, ApiGroupUserFindByIdInputProps>

export const apiGroupUserFindUsersById = async (data: ApiGroupUserFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiGroupUserFindUsersOutputProps>(`/api/group/users/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(findUser({ data: res.data.list }));
    }
    return res;
};